angular.module('shared').directive('readMore', ["$rootScope", "$timeout", function($rootScope, $timeout) {
  return {
    restrict: 'E',
    scope: {
      text: '=',
      maxHeight: '@'
    },
    template: `<div class="read-more" ng-class="{'read-more--trimmed' : isTrimmed}">
  <div class="js-read-more--full-content"
    ng-bind-html="text | linky : '_blank'"
  ></div>
</div>
<a ng-click="toggle()" ng-if="isExpanded || shouldBeTrimmed()">
  {{isExpanded ? 'show less' : 'read more'}}
</a>`,
    link: {
      post: function($scope, element) {
        var fullContent, truncateContent, visibleContent;
        fullContent = function() {
          return angular.element(element[0].querySelector('.js-read-more--full-content'));
        };
        visibleContent = function() {
          return angular.element(element[0].querySelector('.read-more'));
        };
        $scope.shouldBeTrimmed = function() {
          return parseInt(fullContent().css('height')) > parseInt($scope.maxHeight);
        };
        truncateContent = function() {
          return $timeout(function() {
            if ($scope.shouldBeTrimmed()) {
              $scope.isTrimmed = true;
              return visibleContent().css({
                'max-height': $scope.maxHeight
              });
            }
          });
        };
        $timeout(function() {
          return truncateContent();
        });
        return $scope.toggle = function() {
          var height;
          height = $scope.isExpanded ? $scope.maxHeight : 'none';
          visibleContent().css({
            'max-height': height
          });
          $scope.isTrimmed = height === $scope.maxHeight;
          return $scope.isExpanded = !$scope.isExpanded;
        };
      }
    }
  };
}]);
